export default __webpack_public_path__ + "static/media/slide3.0a912f0c.jpg";